<template>
  <div class="mt__main">
    <div class="mt__banner" id="top"></div>
    <div class="mt__center">
      <div class="flex-row main-product">
        <!-- @tab-click="tabClick" -->
        <div style="flex: 0 0 25%">
          <RecursiveMenu
            v-bind="menuProp"
            :data="menu"
            class="custom-scrollbar"
            :class="{ mt__sticky: sticky }"
            :style="{
              width: sticky ? '300px' : '90%',
              height: '80%',
              overflow: 'auto'
            }"
            @select="handleSelct"
          />
        </div>
        <div class="content-product flex-col items-center">
          <img src="../assets/product/blocks.gif" />
          <div class="info-box flex-col items-center">
            <p>
              <strong>
                <span class="label-text">名通 ·&nbsp;产品&amp;技术</span>
              </strong>
            </p>
            <p>
              名通科技公司致力于提供一流的信息技术解决方案和服务，持续为客户创造价值。公司产品经过不断演进、迭代，已形成位置大数据、网络自智、掌端APP三大类主营优势产品，并提供通用技术能力，大幅提升系统开发和运维效率。
            </p>
            <img class="loadbar" src="../assets/product/loadbar.gif" />
          </div>
          <template v-for="(product, index) in products">
            <div :key="product.id" class="product-doc flex-col">
              <div
                class="product-doc_title"
                :id="product.id"
                :data-scroll="product.id"
              >
                <div class="title-img">
                  <img src="../assets/pen.png" alt="图片" data-fail="0" />
                </div>
                <div class="title-text">
                  <p>
                    {{ getTitle(product.title, index) }}
                  </p>
                </div>
              </div>
              <div class="product-doc_content info-box flex-col items-center">
                <template v-if="product.document">
                  <template v-for="(item, order) in product.document">
                    <div :key="order" :class="[`doc-${item.type}`]">
                      <template v-if="item.type === 'text'">
                        <strong v-if="order === 0">
                          <span class="label-text">{{
                            product.title + "："
                          }}</span>
                        </strong>
                        <span class="info-text"> {{ item.value }}</span>
                      </template>
                      <template v-if="item.type === 'img'">
                        <img :src="item.value" alt="图片" />
                      </template>
                      <template v-if="item.type === 'subheading'">
                        <strong>
                          <span class="label-text">{{
                            getTitle("", item.index)
                          }}</span>
                        </strong>
                        <span
                          class="subheading"
                          :data-scroll="`${product.id}_${item.index}`"
                          >{{ item.value }}</span
                        >
                      </template>
                    </div>
                  </template>
                </template>
                <img class="loadbar" src="../assets/product/loadbar.gif" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabs from "./tabs.vue";
// import productsInfo from "./productsInfo.vue";
import productsInfo from "../assets/productInfos.js";
import RecursiveMenu from "./RecursiveMenu/RecursiveMenu.vue";
function integerPrefix(num, n) {
  return (Array(n).join(0) + num).slice(-n);
}
export default {
  mixins: [tabs],
  name: "product",
  components: { RecursiveMenu },
  data() {
    this.products = productsInfo;
    return {
      tabName: "product",
      scrollTop: {},
      menu: [],
      selInfo: { index: null, indexPath: null }
    };
  },
  computed: {
    menuProp() {
      let data = {
        "default-active": "",
        "default-openeds": [],
        "default-select": ""
      };
      if (this.selInfo.index) {
        data["default-select"] = this.selInfo.index;
        data["default-active"] = this.selInfo.index;
      }
      if (this.selInfo.indexPath) {
        data["default-openeds"].push(...this.selInfo.indexPath);
      }
      return data;
    }
  },
  watch: {
    activeName(newVal, oldVal) {
      if (this.selInfo.index === newVal) return;
      Object.assign(this.selInfo, { index: newVal, indexPath: [newVal] });
    }
  },
  created() {
    for (const product of this.products) {
      this.scrollTop[product.id] = 0;
    }
    this.getMenu();
  },
  mounted() {
    const $label = this.$el.querySelector(`[data-scroll=${this.activeName}]`);
    let path = [];
    if (this.activeName.includes("_")) {
      path.push(this.activeName.splice("_")[0])
    } else {
      path.push(this.activeName)
    }
    Object.assign(this.selInfo, { index: this.activeName, indexPath: path });
    if ($label) {
      $label.scrollIntoView({ behavior: "auto", block: "center" });
    }
  },
  updated() {},
  methods: {
    getTitle(title, index) {
      return `${integerPrefix(index + 1, 2)} ${title}`;
    },
    getMenu() {
      this.menu = this.products.reduce((pre, next) => {
        let data = {
          id: next.id,
          name: next.name,
          children: []
        };
        data.children = next.document
          .filter(item => item.type === "subheading")
          .sort((a, b) => (a.index > b.index ? 1 : -1))
          .map(item => {
            let node = {
              id: `${next.id}_${item.index}`,
              name: item.value,
              children: []
            };
            return node;
          });
        pre.push(data);
        return pre;
      }, []);
    },
    getMenuNode() {},
    handleSelct(index, indexPath) {
      this.selInfo = { index, indexPath };
      const $label = this.$el.querySelector(`[data-scroll=${index}]`);
      if ($label) {
        $label.scrollIntoView({ behavior: "auto", block: "center" });
      }
    }
  }
};
</script>
<style scoped>
.mt__banner {
  background-image: url("../assets/product/carousel0.png");
}

hr:last-child {
  display: none;
}

.label-text {
  font-size: 15px;
  letter-spacing: 1px;
}
.doc-subheading .label-text {
  font-style: italic;
}

.main-product {
  width: 100%;
}
.content-product {
  font-family: 思源黑体;
  letter-spacing: 1px;
}
.product-doc {
  margin-bottom: 12px;
}

.product-doc .info-text {
  text-indent: 31.68px;
  color: rgb(67, 67, 67);
  font-size: 14px;
  letter-spacing: 0.578px;
  text-wrap: wrap;
}
.product-doc .product-doc_title {
  margin: 0 auto 12px;
}
.product-doc .product-doc_title .title-img {
  width: 24px;
  transform: rotate(0deg);
}
.product-doc .product-doc_title .title-img img {
  display: block;
  width: 100%;
  height: auto;
}
.product-doc .product-doc_title .title-text {
  margin-top: -25px;
  background-color: rgb(209, 182, 147);
  border-radius: 8px;
  padding: 5px 30px;
  width: fit-content;
}
.product-doc .product-doc_title .title-text p {
  margin: 0;
  color: #fff;
  line-height: 15px;
}
.product-doc_content .doc-img {
  margin: 20px auto;
  width: 480px;
}
.product-doc_content .doc-img img {
  width: 100%;
}
.product-doc_content .doc-subheading {
  width: 100%;
}
.info-box {
  padding: 24px 22px 40px;
  margin: 0 20px 20px;
  border: 1px solid rgb(209, 182, 147);
  position: relative;
}
.info-box .loadbar {
  position: absolute;
  bottom: -12px;
}
.subheading {
  background-color: rgb(209, 182, 147);
  color: #fff;
  padding: 5px 12px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue